// src/components/ProPetCard.js

import React, { useContext } from 'react';
import './ProPetCard.css';
import { renderGenderIcon } from '../utils/genderIcons';
import { IoSettingsOutline, IoEyeOutline, IoHeartOutline   } from "react-icons/io5";
import { ModalContext } from '../context/ModalContext';
import { TabContext } from '../context/TabContext';
import ModalPetDetail from './ModalPetDetail';

// Formatea "YYYY-MM-DD" a "DD/MM/YYYY"
function formatDate(dateStr) {
  const d = new Date(dateStr);
  return isNaN(d) ? dateStr : d.toLocaleDateString();
}

const ProPetCard = ({ pet }) => {
  const { openModal, modalStacks } = useContext(ModalContext);
  const { activeTab } = useContext(TabContext);

  const handleCardClick = e => {
    e.stopPropagation();
    if (modalStacks[activeTab]?.some(m => m.metadata?.petId === pet.id)) return;
    openModal(
      // Le pasamos solo petId, para que ModalPetDetail haga GET /api/pets/:id
      <ModalPetDetail petId={pet.id} />,
      {
        tab: activeTab,
        metadata: { petId: pet.id, petName: pet.nombre, petSexo: pet.sexo },
        overlayClassName: 'pet-detail-overlay'    //  IMPORTANTE para abrir los modales con el ancho máximo (Skeleton)
      }
    );
  };

  // Handler botón configuración (por ahora solo un console.log)
  const handleSettings = e => {
    e.stopPropagation();
    console.log('Abrir configuración de la tarjeta de mascota', pet.id);
    // aquí podrías abrir un modal de configuración...
  };

  return (
    <div className="pro-pet-card" onClick={handleCardClick}>
      <div className="pro-pet-image-container">
        {pet.fotos?.length
          ? <img src={pet.fotos[0].url_imagen} alt={pet.nombre} className="pro-pet-image" loading="lazy" />
          : <div className="pro-pet-image-placeholder">Sin Imagen</div>
        }
      </div>

      <div className="pro-pet-info">
        {/* 1ª fila: Profesional + botón configuración */}
        <div className="pro-professional-row">
          <div className="pro-prof-left">
            {pet.profesional?.logo
              ? <img src={pet.profesional.logo} alt={pet.profesional.nombre}
                     className="pro-prof-logo" loading="lazy" />
              : <div className="pro-prof-logo-placeholder" />
            }
            <span className="pro-prof-name">{pet.profesional?.nombre}</span>
          </div>
          <button
            className="pro-settings-button"
            onClick={handleSettings}
            aria-label="Configuración"
          >
            <IoSettingsOutline size={18} />
          </button>
        </div>

        {/* 2ª fila: Nombre + Sexo */}
        <div className="pro-pet-name-row">
          <div className="pro-pet-name-left">
            {renderGenderIcon(pet.sexo)}
            <span className="pro-pet-name">{pet.nombre}</span>
          </div>
        </div>

        {/* Fila 3: fecha de llegada */}
        {pet.f_publicacion && (
          <div className="pet-date-row">
          Llegó: {formatDate(pet.f_publicacion)}
        </div>
        )}
      </div>

      {/* Estadísticas: likes + visitas */}
      <div className="pro-pet-stats">
        <div className="stat-item">
          <IoHeartOutline className="stat-icon" /> <span>{pet.n_likes ?? 0}</span>
        </div>
        <div className="stat-item">
          <IoEyeOutline className="stat-icon" /> <span>{pet.n_visitas ?? 0}</span>
        </div>
      </div>
    </div>
  );
};

export default ProPetCard;
